import { benefitApi } from '../services/benefitApi';
export function useVoucherPartner() {
    const { data: partner, isLoading, error } = benefitApi.useGetPartnersQuery({ benefitPartner: 'VR' });
    const getErrorMessage = () => {
        if (!error)
            return null;
        if ('data' in error) {
            const errorData = error.data;
            return errorData?.message ?? 'Erro ao carregar parceiro VR';
        }
        return 'Erro de conexão';
    };
    return {
        partner: partner ?? null,
        isLoading,
        error: getErrorMessage(),
    };
}
